<div class="subscription-container" [class.mobile]="isMobile">
  <div class="background-container"></div>
  <div class="content-wrapper">
    <div class="header-section">
      <h1 class="main-title">Share 3D as You Intended.</h1>
      <div class="program-info">
        <p class="program-title">3DWay Artist Program</p>
        <p class="program-price">$65/year</p>
      </div>
      <p class="program-description">
        Membership lets you upload models, share device-fit renders and analyze what resonates.
      </p>
    </div>

    <div class="devices-section">
      <div class="macbook-container">
        <img class="macbook-frame" src="assets/images/new-landing/device-macbook.svg" alt="Macbook">
        <video class="macbook-video" autoplay loop muted playsinline>
          <source src="assets/images/new-landing/pricing_part_model_video_web_desk.mp4" type="video/mp4">
        </video>
        <div class="phone-container">
          <img class="phone-frame" src="assets/images/new-landing/device-phone.svg" alt="Phone">
          <video class="phone-video" autoplay loop muted playsinline>
            <source src="assets/images/new-landing/pricing_part_model_video_app_mobile_2x.mp4" type="video/mp4">
          </video>
        </div>
      </div>
    </div>

    <div class="footer-section">
      <p class="terms-text" *ngIf="!isMobile">
        By continuing you agree to our <a href="/legal/terms-of-service">Terms of Service</a> and <a href="/legal/privacy-policy">Privacy Policy</a>.
      </p>
      <p class="terms-text" *ngIf="isMobile">
        You can’t Join membership in the app.<br>We know, it’s not ideal.
      </p>

      <mat-dialog-actions align="center" class="join-membership-actions">
        <button
          [disabled]="isDisabled"
          class="back-btn"
          (click)="onBackClick()">
          <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.9823 1.5L0.833008 10L10.9823 18.5" stroke="white" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
          <span class="web-btn-text">Back</span>
        </button>

        <button [disabled]="isDisabled" class="subscribe-btn" (click)="onMainBtnClick($event)">
          <span *ngIf="!isDisabled">{{mainBtnTitle}}</span>
          <ng-container *ngIf="isDisabled">
            &nbsp;
            <span>
              <div class="circle-progress-bar-wrapper navbar-progress">
                <div class="pie spinner"></div>
                <div class="pie backcolor"></div>
              </div>
            </span>
          </ng-container>
        </button>

        <!-- THIS IS DONE FOR PROPER ALIGNMENT IN A FAST WAY -->
        <button
          *ngIf="this.userDataService.userSubscriptionStatus !== SUBSCRIPTION_STATUS.GUEST"
          class="back-btn hidden-btn"
          [hidden]="true"
          style="visibility: hidden;">
          <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.9823 1.5L0.833008 10L10.9823 18.5" stroke="white" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
          <span class="web-btn-text">Back</span>
        </button>
        <button
          *ngIf="this.userDataService.userSubscriptionStatus === SUBSCRIPTION_STATUS.GUEST"
          class="free-trial-btn"
          (click)="onFreeTrialClick()">
          <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12.5" cy="12.5" r="12.5" fill="white" />
            <path d="M10.834 6.66669L16.0781 11.9108C16.4035 12.2362 16.4035 12.7638 16.0781 13.0893L10.834 18.3334"
              stroke="black" stroke-width="1.66667" stroke-linecap="round" />
          </svg>
          <span class="web-btn-text" (click)="onFreeTrialClick()">Free Trial</span>
        </button>
      </mat-dialog-actions>
    </div>
  </div>
</div>
